export default __webpack_public_path__ + "locales/tr/RoomLogoCover.json?hash=af19dcbc8a2155aead26dc03fe859b90";